<template>
    <v-container
      fluid
      class="fill-height pa-0"
    >
      <v-row
        justify="center"
        align="center"
        class="fill-height ma-0"
      >
    <loading-screen/>
      </v-row>
    </v-container>
</template>

<script>
  import LoadingScreen from "../components/Helpers/LoadingScreen"
  import {getAllScopes} from "../api/api-auth"

  export default {
    name: "RedirectRegister",
    components: {LoadingScreen},

    created() {
      let registerHint = ''
      if(this.$route.params.email) {
        registerHint = atob(this.$route.params.email)
      }
      let registerKey = ""
      if(this.$route.query.register_key) {
        registerKey = this.$route.query.register_key
      }

      this.$apiAuth.oauthAuthorizationCode(
        getAllScopes(),
        "register",
        registerHint,
        registerKey
      )
    }
  }
</script>

<style scoped lang="scss">
</style>